import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/store';
import { BonusSettlementsPoolDetailState } from './bonus-settlements-pool-detail-reducer';

const bonusSettlementDetailState = (state: AppState): BonusSettlementsPoolDetailState => {
    return state.bonusSettlements.poolDetail;
};

export const bonusSettlementPoolDetailSuppliersSelector = createSelector(bonusSettlementDetailState, state => ({
    poolBonusSettlementCustomerSuppliers: state.poolBonusSettlementCustomerSuppliers,
}));

export const bonusSettlementPoolDetailSidebarSelector = createSelector(bonusSettlementDetailState, state => ({
    poolBonusSettlementCustomerDetails: state.poolBonusSettlementCustomerDetails,
}));
